import { render, staticRenderFns } from "./changeMethod.vue?vue&type=template&id=31532e37"
import script from "./changeMethod.vue?vue&type=script&lang=ts"
export * from "./changeMethod.vue?vue&type=script&lang=ts"
import style0 from "./changeMethod.vue?vue&type=style&index=0&id=31532e37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports